import Scene from "./scene";

let scene;

// Item
class Item {
  constructor(el, scroll) {
    this.scroll = scroll;
    this.DOM = { el };
    this.animated = false;
    this.isBeingAnimatedNow = false;
    this.shouldRollBack = false;
    this.shouldUnRoll = false;
    this.positions = [];

    this.getSize();
    this.mesh = scene.createMesh({
      width: this.width,
      height: this.height,
      src: this.src,
      image: this.DOM.el,
      iWidth: this.DOM.el.width,
      iHeight: this.DOM.el.height,
    });
    scene.scene.add(this.mesh);

    let options = {
      root: null,
      rootMargin: "0px",
      threshold: [0, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    };
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.positions.push(entry.boundingClientRect.y);
        let compareArray = this.positions.slice(
          this.positions.length - 2,
          this.positions.length
        );
        let down = compareArray[0] > compareArray[1] ? true : false;

        this.isVisible = entry.intersectionRatio > 0.0;

        this.shouldRollBack = false;
        this.shouldUnRoll = false;
        if (
          entry.intersectionRatio < 0.5 &&
          entry.boundingClientRect.y > 0 &&
          this.isVisible &&
          !down
        ) {
          this.shouldRollBack = true;
        }

        if (
          entry.intersectionRatio > 0.5 &&
          entry.boundingClientRect.y > 0 &&
          this.isVisible
        ) {
          this.shouldUnRoll = true;
        }
        // console.log(this.isVisible, "vis");
        this.mesh.visible = this.isVisible;
      });
    }, options);
    this.observer.observe(this.DOM.el);
    // init/bind events
    window.addEventListener("resize", () => this.resize());
    this.render();
  }

  getSize() {
    const bounds = this.DOM.el.getBoundingClientRect();
    // console.log(bounds)
    // const fromTop = bounds.top;
    // const windowHeight = window.innerHeight;
    // const withoutHeight = fromTop - windowHeight;
    // const withHeight = fromTop + bounds.height;
    // this.insideTop = withoutHeight - this.docScroll;
    // this.insideRealTop = fromTop + this.docScroll;
    // this.insideBottom = withHeight - this.docScroll + 50;
    // this.top = bounds.top + (window.pageYOffset || document.documentElement.scrollTop);
    this.top = bounds.top;
    this.width = bounds.width;
    this.height = bounds.height;
    // this.left = bounds.left;
    this.left = bounds.left;
  }
  resize() {
    // on resize rest sizes and update the translation value
    this.getSize();
    // this.mesh.scale.set(this.width, this.height, 200);
    // this.render(this.scroll.renderedStyles.translationY.current);
    this.render();
    this.scroll.shouldRender = true;
  }

  render() {
    // this.currentScroll = currentScroll;
    // this.mesh.position.y = currentScroll + winsize.height / 2 - this.insideRealTop - this.height / 2;
    this.mesh.position.x =
      0 - window.innerWidth / 2 + this.left + this.width / 2;
    this.mesh.position.y =
      0 - this.top - this.height / 2 + window.innerHeight / 2;
    this.mesh.scale.set(this.width, this.height, this.width / 2);
    // this.mesh.position.x = this.left;
    // this.mesh.position.y = this.top;

    // console.log(currentScroll)
    // console.log(this.mesh.position.y, this.mesh.position.x)
  }
}

// SmoothScroll
export default class SmoothScroll {
  constructor(callback) {
    // this.docScroll = window.pageYOffset || document.documentElement.scrollTop
    this.shouldRender = true;
    this.DOM = { main: document.querySelector("#main") };
    this.items = [];
    scene = new Scene("container");
    scene.init(function() {
      callback();
    });
    this.createItems();
    this.listenMouse();

    requestAnimationFrame(() => this.render());
  }
  listenMouse() {
    document.addEventListener("mousemove", (event) => {
      if (event.target && event.target.classList.contains("hero_cover")) {
        // console.log(this.docScroll )
        scene.setMouse(
          event.clientX / scene.width,
          1 - (event.clientY / scene.height)
        );

        this.shouldRender = true;
      }
    });
    document.addEventListener("touchmove", (event) => {
      if (event.target && event.target.classList.contains("hero_cover")) {
        // console.log(this.docScroll )
        scene.setMouse(
          event.touches[0].clientX / scene.width,
          1 - (event.touches[0].clientY / scene.height)
        );

        this.shouldRender = true;
      }
    });
  }
  setPosition() {
    if (scene.targetSpeed > 0.01) this.shouldRender = true;

    if (this.shouldRender) {
      // console.log('scene render')
      this.shouldRender = false;
      scene.render();
    }
  }
  createItems() {
    const images = document.querySelectorAll(".js-image");
    images.forEach((image) => {
      this.items.push(new Item(image, this));
    });
  }
  render() {
    // console.log('render')
    // update the current and interpolated values
    // for (const key in this.renderedStyles) {
    //   this.renderedStyles[key].current = this.renderedStyles[key].setValue();
    //   this.renderedStyles[key].previous = MathUtils.lerp(
    //     this.renderedStyles[key].previous,
    //     this.renderedStyles[key].current,
    //     this.renderedStyles[key].ease
    //   );
    // }
    // and translate the scrollable element
    this.setPosition();

    // loop..
    // setTimeout(requestAnimationFrame(() => this.render()), 1000000 / 60)
    requestAnimationFrame(() => this.render());
  }
}
